<template>
  <div class="clips">
    <div v-for="clip in clips" :key="clip.external_id" class="clip">
      <div class="name">{{ clip.name }}</div>
      <iframe id="ytplayer" type="text/html" :src="clip.external_id | getYoutube" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Clips',
  props: {
    clips: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    getYoutube: function(value) {
      return `https://www.youtube.com/embed/${value}?autoplay=0&origin=https://filmr.petter.me`;
    },
  },
};
</script>

<style lang="scss">
.clips {
}
</style>
